import React from 'react'
import './two_section_content.scss'
import { Col, Row } from 'react-bootstrap';


const TwoSectionContent = () => {
    return (
        <div className='two_section_content'>
            <div className='top-details'>
                <h3>We keep things simple</h3>
                <p>Many 401(k) plans provide different services, like recordkeeping and investment management, through multiple vendors. At Sentry, we offer you the dedicated service you deserve—all in-house.</p>
            </div>
            <Row className='mb-5'>
                <Col md={6} sm={12}>
                    <div className='main-content'>
                        <h4>Our one-team, one-company approach</h4>
                        <p>This approach benefits you because it’s cost efficient. Our services are done in-house, which means we don’t need to pass additional fees along to you.</p>
                    </div>
                </Col>
                <Col md={6} sm={12}>
                    <div className='main-content'>
                        <h4>We have your best interest in mind</h4>
                        <p>We work with trusted companies—Mesirow and Morningstar—to help you manage your fiduciary responsibilities. We also strive to be transparent with you. We share fee disclosures and don’t deduct commissions from plan assets.</p>
                    </div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col md={6} sm={12}>
                    <div className='main-content'>
                        <h4>We have experience you can trust</h4>
                        <p>401(k) plans are our specialty. Unlike some other service providers, we're not distracted by other financial activities like wealth management or estate planning.</p>
                    </div>
                </Col>
                <Col md={6} sm={12}>
                    <div className='main-content'>
                        <h4>You can count on our financial strength</h4>
                        <p>With more than $25 billion in assets and a policyholder surplus of $8 billion**, we’ve been providing retirement plan solutions to businesses like yours for more than 50 years.</p>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default TwoSectionContent;
